import React, {useState} from 'react'
import PinterestIcon from '@material-ui/icons/Pinterest';
import styled from 'styled-components'
import IconButton from '@material-ui/core/IconButton';
import NotificationsIcon from '@material-ui/icons/Notifications';
import SmsIcon from '@material-ui/icons/Sms';
import FaceIcon from '@material-ui/icons/Face';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SearchIcon from '@material-ui/icons/Search';


function Header(props) {

    const[input,setInput]=useState("");

    const onSearchSubmit =(e) => {
        e.preventDefault();
        props.onSubmit(input);
        
    }

    return (
        <Wrapper>
            <LogoWrapper>
                <IconButton>
                    <PinterestIcon/>
                </IconButton>
            </LogoWrapper>
            <HomePageButton>
                <a href="/">Homepage</a>
            </HomePageButton>
            <FollowingButton>
                <a href="/">Following</a>
            </FollowingButton>
            <SearchWrapper>
                <SearchBarWrapper>
                    <IconButton>
                        <SearchIcon/>
                    </IconButton>
                    <form>
                        <input type="text" onChange={(e) => setInput(e.target.value)} />
                        <button type="submit" onClick={onSearchSubmit}></button>
                    </form>
                </SearchBarWrapper>
            </SearchWrapper>
            <IconsWrapper>
                <IconButton>
                    <NotificationsIcon/>
                </IconButton>
               <IconButton>
                    <SmsIcon/>
               </IconButton>
               <IconButton>
                    <FaceIcon/>
               </IconButton>
               <IconButton>
                    <ExpandMoreIcon/>
               </IconButton>
            </IconsWrapper>
        </Wrapper>
    )
}

export default Header

const Wrapper = styled.div`
display:flex;
align-items:center;
height:56px;
padding:12px 4px 4px 16px;
background-color:white;
color:black;
`
const LogoWrapper =styled.div`
.MuiSvgIcon-root {
    color:#e60023;
    font-size:32px;
    cursor:pointer;
}
`
const HomeButton= styled.div`
display:flex;
height:48px;
min-width:123px;
align-items:center;
justify-content:center;
border-radius:24px;
cursor:pointer;
`
const HomePageButton= styled(HomeButton)` 

background-color:rgb(17,17,17);
a{
    text-decoration:none;
    color:white;
    font-weight:700;
}
`
const FollowingButton = styled(HomeButton)`

background-color:white;
a{
    text-decoration:none;
    color:black;
    font-weight:700;
}
:hover{
    background-color:#e1e1e1;
}
`
const SearchWrapper = styled.div` 
flex:1;

`
const SearchBarWrapper = styled.div`
background-color:#efefef;
display:flex;
height:48px;
width:100%;
border-radius:50px;
border:9px;
padding-left:10px;
form{
    display:flex;
    flex:1;
}
form> input{
    background-color: transparent;
    border:none;
    width:100%;
    margin-left:5px;
    font-size:16px;
}
form >button{
    display:none;
}
input:focus{
    outline:none;
}
`
const IconsWrapper = styled.div`
`